import { useFormState, useWatch } from 'react-hook-form';
import { requiredOk } from '../../../utils';

export const useOfficeInformation = (control) => {
  const watchedValues = useWatch({
    control,
    name: [
      'timePerPatientRDH',
      'timePerPatientDA',
      'timePerPatientDN',
      'isAssistedHygiene',
      'productivity',
      'partnershipOrganization',
      'partnershipCode',
    ],
  });

  const { dirtyFields } = useFormState({ control });

  const formValues = {
    timePerPatientRDH: watchedValues[0],
    timePerPatientDA: watchedValues[1],
    timePerPatientDN: watchedValues[2],
    isAssistedHygiene: watchedValues[3],
    productivity: watchedValues[4],
    partnershipOrganization: watchedValues[5],
    partnershipCode: watchedValues[6],
  };

  const timeFields = ['timePerPatientRDH', 'timePerPatientDA', 'timePerPatientDN'];

  const isTimerPerPatientValid =
    timeFields.every((key) => formValues[key] !== '') && // Ensure no field is empty
    timeFields.some((key) => formValues[key] !== 'N/A'); // At least one field is not 'N/A'

  const isAssistedHygieneValid = formValues.isAssistedHygiene !== undefined;

  const isValid = isTimerPerPatientValid && isAssistedHygieneValid;

  const isAnyTimePerPatientDirty = Boolean(
    dirtyFields.timePerPatientRDH ||
      dirtyFields.timePerPatientDA ||
      dirtyFields.timePerPatientDN,
  );

  const canSave =
    requiredOk(isAnyTimePerPatientDirty, isTimerPerPatientValid) &&
    requiredOk(dirtyFields.isAssistedHygiene, isAssistedHygieneValid);

  return {
    formValues,
    isValid,
    isTimerPerPatientValid,
    canSave,
  };
};
